// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-expat-explore-travel-js": function componentSrcPagesExpatExploreTravelJs() {
    return import("./../../src/pages/expat-explore-travel.js"
    /* webpackChunkName: "component---src-pages-expat-explore-travel-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-iot-global-awards-js": function componentSrcPagesIotGlobalAwardsJs() {
    return import("./../../src/pages/iot-global-awards.js"
    /* webpackChunkName: "component---src-pages-iot-global-awards-js" */
    );
  },
  "component---src-pages-red-sofa-cafe-js": function componentSrcPagesRedSofaCafeJs() {
    return import("./../../src/pages/red-sofa-cafe.js"
    /* webpackChunkName: "component---src-pages-red-sofa-cafe-js" */
    );
  },
  "component---src-pages-wkm-payment-gateway-js": function componentSrcPagesWkmPaymentGatewayJs() {
    return import("./../../src/pages/wkm-payment-gateway.js"
    /* webpackChunkName: "component---src-pages-wkm-payment-gateway-js" */
    );
  }
};